/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-hospital-association.reducer';

export const DoctorHospitalAssociationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorHospitalAssociationEntity = useAppSelector(state => state.doctorHospitalAssociation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorHospitalAssociationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.detail.title">DoctorHospitalAssociation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.id}</dd>
          <dt>
            <span id="joiningDt">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.joiningDt">Joining Dt</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.joiningDt}</dd>
          <dt>
            <span id="leavingDate">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.leavingDate">Leaving Date</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.leavingDate}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.cursor}</dd>
          <dt>
            <span id="dutyStartTime">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.dutyStartTime">Duty Start Time</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.dutyStartTime}</dd>
          <dt>
            <span id="dutyEndTime">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.dutyEndTime">Duty End Time</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.dutyEndTime}</dd>
          <dt>
            <span id="tmPermanent">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.tmPermanent">Tm Permanent</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.tmPermanent ? 'true' : 'false'}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.createdDtm}</dd>
          <dt>
            <span id="lastModifiedDtm">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.lastModifiedDtm">Last Modified Dtm</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.lastModifiedDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.modifiedBy}</dd>
          <dt>
            <span id="leavingDt">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.leavingDt">Leaving Dt</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAssociationEntity.leavingDt}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.doctor">Doctor</Translate>
          </dt>
          <dd>{doctorHospitalAssociationEntity.doctor ? doctorHospitalAssociationEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorHospitalAssociation.hospital">Hospital</Translate>
          </dt>
          <dd>{doctorHospitalAssociationEntity.hospital ? doctorHospitalAssociationEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-hospital-association" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-hospital-association/${doctorHospitalAssociationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorHospitalAssociationDetail;
